<template>
  <CContainer
    fluid
    class="d-flex content-center min-vh-100"
    style="background-color: #f0f0f0"
  >
    <CCol lg="5">
      <CCardGroup>
        <CCard class="py-0">
          <CCardBody
            class="p-0"
            style="
              border-radius: 5px;
              box-shadow: 0 4px 10px -1px rgb(200 200 200 / 80%);
            "
          >
            <CContainer>
              <!-- <CIcon
                class="mx-2 px-2"
                :src="require('@/assets/logoNova.png')"
                :height="30"
                :fluidGrow="true"
                style="margin-top: 1rem"
              /> -->
              <CIcon
                name="logo"
                :fluidGrow="true"
                style="margin-top: 1.5rem;"
                width="302"
                height="40"
              />
              <CRow alignVertical="center">
                <CCol class="my-auto" style="padding-bottom: 5px">
                  <CForm>
                    <h2>Login</h2>
                    <p class="text-muted">Entrar na sua conta</p>
                    <CInput
                      placeholder="Email"
                      v-model="user.email"
                      type="text"
                      autocomplete="username email"
                      :rules="emailRules"
                      required
                      style="padding: 0px 16px"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-user" />
                      </template>
                    </CInput>
                    <CInput
                      placeholder="Senha"
                      v-model="user.password"
                      :type="show ? 'password' : 'text'"
                      autocomplete="curent-password"
                      :rules="passwordRules"
                      required
                      style="padding: 0px 16px"
                    >
                      <div slot="append-content">
                        <CButton @click="show = !show">
                          <font-awesome-icon
                            size="1x"
                            color="#FFFFF"
                            :icon="show ? ['fa', 'eye'] : ['fa', 'eye-slash']"
                          />
                        </CButton>
                      </div>
                      <template #prepend-content>
                        <CIcon name="cil-lock-locked" />
                      </template>
                    </CInput>
                    <CCol class="mx-auto" lg="4">
                      <div class="form-group form-actions" align="center">
                        <LoadingButton
                          :showSpinner="carregando"
                          texto="Entrar"
                          @onSubmit="submit()"
                        />
                      </div>
                    </CCol>
                  </CForm>
                </CCol>
              </CRow>
            </CContainer>
          </CCardBody>
        </CCard>
      </CCardGroup>
    </CCol>
    <MensagemModal
      :mensagem="errorObject"
      :showModal="errorModal"
      @onCancel="errorModal = false"
    />
  </CContainer>
</template>


<script>
const axios = require("axios");
import { LoadingButton, MensagemModal } from "../components/global";
import { AuthService } from "../services";

// const image = new Image();
// image.src = "@/assets/logoNova.png";
export default {
  components: { MensagemModal, LoadingButton },
  metaInfo: {
    title: "Sistema Bikers",
    titleTemplate: "Login - %s",
  },
  $_veeValidate: {
    validator: "new",
  },
  data() {
    return {
      mensagem: "",
      titulo: "",
      show: true,
      logado: false,
      carregando: false,
      user: {
        email: "",
        password: "",
      },
      senha_visivel: false,
      password: "",
      passwordRules: [(v) => !!v || "Senha é obrigatória"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail é obrigatório",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido",
      ],
      errorObject: {
        titulo: "",
        color: "danger",
        message: "",
      },
      errorModal: false,
    };
  },
  created() {
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (503 === error.headers) {
          return this.$router.push("/");
        } else {
          return Promise.reject(error);
        }
      }
    );
    if (this.$store.getters.getLogado) {
      this.$router.push("/home");
    }
  },
  methods: {
    getUrlImg() {
      return "./assets/logoNova.png";
    },
    clicou(data) {
      this.$socket.client.emit("ChatMessage", data);
    },
    getColorTeste(x) {
      if (x) {
        if (window.location.hostname == "teste.bikersecodelivery.com.br")
          return "#0093ff";
        else return "#00a65a";
      } else {
        if (window.location.hostname == "teste.bikersecodelivery.com.br")
          return "login-teste";
        else return "login";
      }
    },
    submit() {
      if (this.user.email == "" || this.user.password == "") {
        return;
      }
      this.carregando = true;
      const credentialsEncrypted = AuthService.encryptCredentials({
        email: this.user.email,
        password: this.user.password,
      });
      axios
        .post(sessionStorage.getItem("url") + "/api/login", null, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + credentialsEncrypted,
          },
        })
        .then(async (response) => {
          this.carregando = false;

          if (response && !response.data) {
            this.errorObject = {
              titulo: "Erro de Servidor",
              color: "danger",
              message:
                "Acesso negado ao banco de dados, por favor contate um administrador.",
            };
            this.errorModal = true;
            return;
          }

          const { status, access_token } = response.data;

          if (status) {
            if (status == "Maintenence") {
              this.$store.commit("DESTROY_USER");
              this.$router.push("*");
            }
            if (status == "Token is Expired") {
              this.$store.commit("DESTROY_USER");
              this.$router.push("/");
            }
          }
          console.log(access_token);
          if (access_token != null) {
            await this.$store.commit("SET_TOKEN", access_token);
            await this.$store.commit("SET_LOGADO", true);
            await this.$store
              .dispatch("getUserAPI", access_token)
              .then(() => this.$router.push("/home"));
          }
        })
        .catch((error) => {
          this.carregando = false;
          this.mensagem = error;
          console.log(error)
          if (this.mensagem == "Error: Request failed with status code 400") {
            this.titulo = "Credenciais Inválidas";

            this.mensagem =
              "Dados informados inválidos, favor conferir e tentar novamente!";
          } else if (
            this.mensagem == "Error: Request failed with status code 404"
          ) {
            this.titulo = "Erro 404";
            this.mensagem = "Erro, por favor contate um administrador";
          } else if (
            this.mensagem == "Error: Request failed with status code 500"
          ) {
            this.titulo = "Erro 500";
            this.mensagem =
              "Acesso negado ao banco de dados, por favor contate um administrador (.env)";
          } else if (
            this.mensagem == "Error: Request failed with status code 405"
          ) {
            this.titulo = "Erro 405";
            this.mensagem = "Erro, por favor contate um administrador";
          } else if (
            this.mensagem == "Error: Request failed with status code 423"
          ) {
            this.titulo = "Conta desativada";

            this.mensagem =
              "Essa conta foi desativada, entre em contato com o suporte.";
          }
          this.errorObject = {
            titulo: this.titulo,
            color: "danger",
            message: this.mensagem,
          };
          this.errorModal = true;
        });
    },
    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>
<style>
</style>
